import '../fonts/mark_my_words.css';
var mainTheme = {
    name: 'Main Theme',
    breakpoints: {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1920
    },
    spacing: {
        xsmall: 0.5,
        small: 1,
        medium: 1.5,
        large: 2,
        xlarge: 2.5
    },
    layout: {
        page: {
            containerWidth: 1200,
            spacing: 'small'
        },
        menu: {
            mobileSize: 82,
            desktopSize: 50,
            desktopVersionVisibility: ['extra-large'],
            spacing: 'small'
        }
    },
    colors: {
        background: '#F7F9FB',
        blue: {
            default: '#007AFF',
            icons: '#007AFF',
            buttons: '#007AFF',
            progressBar: '#007AFF',
            inputs: '#007AFF',
            text: '#007AFF'
        },
        green: {
            default: '#23D633',
            icons: '#23D633',
            buttons: '#23D633',
            progressBar: '#23D33E',
            inputs: '#23D633',
            text: '#23D633'
        },
        yellow: {
            default: '#FFCC17',
            icons: '#FFCC17',
            buttons: '#FFCC17',
            progressBar: '#FFCC17',
            inputs: '#FFCC17',
            text: '#FFCC17'
        },
        orange: {
            default: '#FFA300',
            icons: '#FFA300',
            buttons: '#FFA300',
            progressBar: '#FF9600',
            inputs: '#FFA300',
            text: '#FFA300'
        },
        red: {
            default: '#E23B33',
            icons: '#E23B33',
            buttons: '#E23B33',
            progressBar: '#E23B33',
            inputs: '#E23B33',
            text: '#E23B33'
        },
        pink: {
            default: '#FF2D55',
            icons: '#FF2D55',
            buttons: '#FF2D55',
            progressBar: '#FF2D55',
            inputs: '#FF2D55',
            text: '#FF2D55'
        },
        violet: {
            default: '#AF58DF',
            icons: '#AF58DF',
            buttons: '#AF58DF',
            progressBar: '#AF58DF',
            inputs: '#AF58DF',
            text: '#AF58DF'
        },
        white: {
            default: '#FFFFFF',
            icons: '#FFFFFF',
            buttons: '#FFFFFF',
            progressBar: '#FFFFFF',
            inputs: '#FFFFFF',
            text: '#FFFFFF'
        },
        'light-grey': {
            default: '#C5C7C8',
            icons: '#C5C7C8',
            buttons: '#D1D1D6',
            progressBar: '#C5C7C8',
            inputs: '#C5C7C8',
            text: '#C5C7C8'
        },
        grey: {
            // e.g. Used at Stats
            default: '#454545',
            icons: '#454545',
            buttons: '#454545',
            progressBar: '#454545',
            inputs: '#454545',
            text: '#454545'
        },
        black: {
            default: '#242424',
            icons: '#242424',
            buttons: '#242424',
            progressBar: '#242424',
            inputs: '#242424',
            text: '#242424'
        }
    },
    verticals: {
        accommodation: 'blue',
        banking: 'green',
        transport: 'orange',
        phone: 'pink'
    },
    typography: {
        fontFamily: ['Poppins', 'Arial', 'sans-serif'].join(','),
        secondaryFontFamily: 'Mark My Words',
        sizes: {
            default: 16,
            body: {
                small: 10,
                medium: 13,
                large: 15,
                xlarge: 20
            },
            headings: {
                small: 17,
                medium: 21,
                large: 25,
                xlarge: 48 // h1
            }
        },
        weights: {
            thin: 200,
            light: 300,
            regular: 400,
            medium: 500,
            semibold: 600,
            bold: 700
        },
        colors: {
            primary: '#242424',
            secondary: '#505052',
            light: '#888888',
            'extra-light': '#C5C7C8',
            danger: '#FF3B30'
        }
    },
    buttons: {
        xxsmall: {
            primary: 30,
            circular: 15,
            text: 8
        },
        xsmall: {
            primary: 42,
            circular: 25,
            text: 10
        },
        small: {
            primary: 48,
            circular: 42,
            text: 13
        },
        medium: {
            primary: 55,
            circular: 55,
            text: 13
        },
        large: {
            primary: 65,
            circular: 65,
            text: 17
        },
        xlarge: {
            primary: 80,
            circular: 80,
            text: 21
        }
    },
    icons: {
        small: 20,
        medium: 25,
        large: 40,
        xlarge: 60
    },
    circleProgress: {
        xsmall: {
            radius: 18,
            circleWidth: 6
        },
        small: {
            radius: 30,
            circleWidth: 6
        },
        medium: {
            radius: 85,
            circleWidth: 10
        },
        large: {
            radius: 100,
            circleWidth: 10
        }
    }
};
export default mainTheme;
//# sourceMappingURL=mainTheme.js.map